define(function(require, exports, module) {
    'use strict';

    var CashierMethodModel = require('portlets/cashier/cashier.method.model');

    module.exports = CashierMethodModel.extend({
        confirmedFields: [
            'beneficialOwnerConfirmed',
            'feeConfirmed',
            'currencyConversion',
            'depositConfirmed',
            'loseBonus',
            'profitTaxConfirmed',
            'personalId'
        ]
    });
});
